import { Category } from './wikis';
import { makeRequest, CommonRequestOptions } from './makeRequest';
import { QuizAssessment } from '~/pages/Courses/_shared/CourseForm/CourseStageEditor/Stage';

type GetCategoriesRequestOptions = CommonRequestOptions & {
   modifiedSince?: number;
   offset?: number;
   limit?: number;
   langid?: string;
};

export async function getCategories({
   modifiedSince,
   offset,
   limit,
   langid,
   ...common
}: GetCategoriesRequestOptions): Promise<Category[]> {
   return await makeRequest('get', 'wikis/CATEGORY', {
      ...common,
      query: {
         modifiedSince,
         offset,
         limit,
         langid,
      },
   });
}

export type SimpleCategory = {
   id: number;
   title: string;
   display_title: string;
   summary: string;
   image: string;
};

export type ChildrenCategoriesResult = SimpleCategory[];

export type GetChildrenCategoriesRequestOptions = CommonRequestOptions & {
   category: string;
};

export async function getChildrenCategories({
   category,
   ...common
}: GetChildrenCategoriesRequestOptions) {
   return await makeRequest('get', `wikis/CATEGORY/${category}/children`, {
      ...common,
   });
}

export type CategoryDocument = {
   docid: number;
   doctype: string;
   title: string;
   release_version: string;
   isPrivate: boolean;
   isArchived: boolean;
   attachedQuiz?: QuizAssessment | null;
   image: string;
};

export type CategoryDocumentsResult = CategoryDocument[];

export type GetCategoryDocumentsRequestOptions = CommonRequestOptions & {
   wikiid: number;
};

export async function getCategoryDocuments({
   wikiid,
   ...common
}: GetCategoryDocumentsRequestOptions) {
   return await makeRequest('get', `wikis/CATEGORY/${wikiid}/documents`, {
      ...common,
   });
}
